import { DeliveryTrip } from "../../../../data/entities";
export const tripNumberLabel = (value?: number | null) => value == null ? "Chưa phân chuyến" : `Chuyến ${value}`;
const businessDay = (value: unknown): string | null => {
    if (value == null || value === "") return null;
    const date = new Date(value as string | number | Date);
    if (Number.isNaN(date.getTime())) return null;
    return new Intl.DateTimeFormat("en-CA", {
        timeZone: "Asia/Ho_Chi_Minh",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(date);
};

export const compareTrips = (a: DeliveryTrip, b: DeliveryTrip) => {
    const aDay = businessDay(a.scheduled_at ?? a.date);
    const bDay = businessDay(b.scheduled_at ?? b.date);
    if (aDay == null && bDay != null) return 1;
    if (aDay != null && bDay == null) return -1;
    return (aDay ?? "").localeCompare(bDay ?? "") ||
        (a.trip_number ?? 6) - (b.trip_number ?? 6) || String(a.id).localeCompare(String(b.id));
};
